__turbopack_context__.v({
  "bagIcon": "CategoryMenuPage-module__6bssOa__bagIcon",
  "bagLink": "CategoryMenuPage-module__6bssOa__bagLink",
  "categoryLink": "CategoryMenuPage-module__6bssOa__categoryLink",
  "categoryLinkActive": "CategoryMenuPage-module__6bssOa__categoryLinkActive",
  "categoryLinks": "CategoryMenuPage-module__6bssOa__categoryLinks",
  "categoryNavBar": "CategoryMenuPage-module__6bssOa__categoryNavBar",
  "categoryNavInner": "CategoryMenuPage-module__6bssOa__categoryNavInner",
  "crossEyebrow": "CategoryMenuPage-module__6bssOa__crossEyebrow",
  "crossGrid": "CategoryMenuPage-module__6bssOa__crossGrid",
  "crossLink": "CategoryMenuPage-module__6bssOa__crossLink",
  "crossNavigation": "CategoryMenuPage-module__6bssOa__crossNavigation",
  "crossRule": "CategoryMenuPage-module__6bssOa__crossRule",
  "editorialDeco": "CategoryMenuPage-module__6bssOa__editorialDeco",
  "editorialIntro": "CategoryMenuPage-module__6bssOa__editorialIntro",
  "eyebrow": "CategoryMenuPage-module__6bssOa__eyebrow",
  "hero": "CategoryMenuPage-module__6bssOa__hero",
  "heroRule": "CategoryMenuPage-module__6bssOa__heroRule",
  "heroTitle": "CategoryMenuPage-module__6bssOa__heroTitle",
  "heroWord": "CategoryMenuPage-module__6bssOa__heroWord",
  "heroWordWrap": "CategoryMenuPage-module__6bssOa__heroWordWrap",
  "highlight": "CategoryMenuPage-module__6bssOa__highlight",
  "highlightCard": "CategoryMenuPage-module__6bssOa__highlightCard",
  "itemAccent": "CategoryMenuPage-module__6bssOa__itemAccent",
  "itemBadge": "CategoryMenuPage-module__6bssOa__itemBadge",
  "itemDosage": "CategoryMenuPage-module__6bssOa__itemDosage",
  "itemHeader": "CategoryMenuPage-module__6bssOa__itemHeader",
  "itemList": "CategoryMenuPage-module__6bssOa__itemList",
  "itemNameGroup": "CategoryMenuPage-module__6bssOa__itemNameGroup",
  "itemPrice": "CategoryMenuPage-module__6bssOa__itemPrice",
  "itemPricing": "CategoryMenuPage-module__6bssOa__itemPricing",
  "menuBrand": "CategoryMenuPage-module__6bssOa__menuBrand",
  "menuItem": "CategoryMenuPage-module__6bssOa__menuItem",
  "menuLayout": "CategoryMenuPage-module__6bssOa__menuLayout",
  "menuLayoutSingleColumn": "CategoryMenuPage-module__6bssOa__menuLayoutSingleColumn",
  "menuSectionBlock": "CategoryMenuPage-module__6bssOa__menuSectionBlock",
  "mobileBottomLink": "CategoryMenuPage-module__6bssOa__mobileBottomLink",
  "mobileBottomLinkActive": "CategoryMenuPage-module__6bssOa__mobileBottomLinkActive",
  "mobileBottomNav": "CategoryMenuPage-module__6bssOa__mobileBottomNav",
  "navActions": "CategoryMenuPage-module__6bssOa__navActions",
  "neutral": "CategoryMenuPage-module__6bssOa__neutral",
  "page": "CategoryMenuPage-module__6bssOa__page",
  "priceAsterisk": "CategoryMenuPage-module__6bssOa__priceAsterisk",
  "primary": "CategoryMenuPage-module__6bssOa__primary",
  "reservationLink": "CategoryMenuPage-module__6bssOa__reservationLink",
  "secondary": "CategoryMenuPage-module__6bssOa__secondary",
  "sectionEyebrow": "CategoryMenuPage-module__6bssOa__sectionEyebrow",
  "sectionHeading": "CategoryMenuPage-module__6bssOa__sectionHeading",
  "sectionsList": "CategoryMenuPage-module__6bssOa__sectionsList",
  "takeaway": "CategoryMenuPage-module__6bssOa__takeaway",
  "takeawayButton": "CategoryMenuPage-module__6bssOa__takeawayButton",
  "takeawayDeco": "CategoryMenuPage-module__6bssOa__takeawayDeco",
  "takeawayInner": "CategoryMenuPage-module__6bssOa__takeawayInner",
  "tertiary": "CategoryMenuPage-module__6bssOa__tertiary",
  "ttcDeco": "CategoryMenuPage-module__6bssOa__ttcDeco",
  "ttcNotice": "CategoryMenuPage-module__6bssOa__ttcNotice",
  "ttcSup": "CategoryMenuPage-module__6bssOa__ttcSup",
  "ttcText": "CategoryMenuPage-module__6bssOa__ttcText",
});
